export default {
  SET_CREDIT: "SET_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION",
  SET_DOWNLOAD_DOCUMENTS: "SET_DOWNLOAD_DOCUMENTS",
  SET_DISABLED_BUTTON: "SET_DISABLED_BUTTON",
  SET_UPLOAD_DOCUMENTS: "SET_UPLOAD_DOCUMENTS",
  SET_END_CREDIT_PROCESS: "SET_END_CREDIT_PROCESS"
}
